import { acceptHMRUpdate, defineStore } from 'pinia';

export interface dataSource {
  dataSources: any[];
}

export const useDataSourceStore = defineStore('dataSource', {
  state: (): dataSource => ({
    dataSources: [],
  }),
  getters: {
    getDataSource: (state) => state.dataSources,
    hasDataSource: (state) => (key: any) => !!state.dataSources[key],
    hasLmsBcrm: (state) => state.dataSources.some((item) => item.sourcekey == 'LmsBcrm'),
  },
  actions: {
    setDataSource(dataSourceList: any[]) {
      // Update the Info state in a single operation
      this.dataSources = dataSourceList;
    },
    resetDataSources() {
      this.$reset();
    },
  },
  persist: {
    key: 'app:dataSource',
    storage: localStorage,
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDataSourceStore, import.meta.hot));
}
